/* eslint camelcase: "off" */

import config from 'config';
import BaseAdapter from 'Core/adapters/base';

class PhotographerAvailabilityAdapter extends BaseAdapter {
  /**
   * Get the photographer availabilities
   *
   * @param {Integer} [photographer_id] - photographer ID
   * @param {Integer} [package_id] - package ID
   * @param {String} date - the date for which to check the availability against
   * @return {Promise} - a promise which will resolve to the availability list
   */
  static get(photographer_id, package_id, date = null) {
    let requestParams = {
      params: {
        package_id: package_id,
        date: date
      }
    };

    return this.prototype.getRequest(`${config['api']['photographerAvailabilities']}/${photographer_id}`, requestParams);
  }
}

export default PhotographerAvailabilityAdapter;



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/adapters/photographerAvailability.js